import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import AllChinaBuySpreadsheetGuide from "@/pages/allchinabuy-spreadsheet-complete-guide/page";
import AllChinaBuyReview from "@/pages/allchinabuy-review/page";
import AllChinaBuyShipping from "@/pages/allchinabuy-shipping-cost/page";
import AllChinaBuyCoupon from "@/pages/allchinabuy-coupon/page";
import AllChinaBuyVs from "@/pages/allchinabuy-vs-superbuy/page";
import AllChinaBuyLegit from "@/pages/allchinabuy-legit-safety/page";
import About from "@/pages/about/page";
import Contact from "@/pages/contact/page";
import Legal from "@/pages/legal/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/allchinabuy-spreadsheet-complete-guide",
    element: <AllChinaBuySpreadsheetGuide />,
  },
  {
    path: "/allchinabuy-review",
    element: <AllChinaBuyReview />,
  },
  {
    path: "/allchinabuy-shipping-cost",
    element: <AllChinaBuyShipping />,
  },
  {
    path: "/allchinabuy-coupon",
    element: <AllChinaBuyCoupon />,
  },
  {
    path: "/allchinabuy-vs-superbuy",
    element: <AllChinaBuyVs />,
  },
  {
    path: "/allchinabuy-legit-safety",
    element: <AllChinaBuyLegit />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/privacy",
    element: <Legal type="privacy" />,
  },
  {
    path: "/terms",
    element: <Legal type="terms" />,
  },
  {
    path: "/disclaimer",
    element: <Legal type="disclaimer" />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;